const Paths = {
  root: "/",
  property: (id: string) => `/property/${id}`,
  properties: "/properties",
  about: "/about",
  contact: "/contact",
  api: {
    email: "/api/email",
  },
};

const isActivePath = (pathname: string, path: string) => {
  return path === pathname;
};

export { Paths, isActivePath };
